module.exports = __webpack_public_path__ + "img/frame-mb.964d8932.webp";